import ReactQueryWrapper from "features/api/ReactQueryWrapper";
import LayoutObserver from "features/LayoutUtils/LayoutObserver";
import ScrollController from "features/ScrollController/ScrollController";
import { SnackbarProvider } from "features/Snackbar/SnackbarProvider";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "../../store";
import RootRouter from "./RootRouter";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-P3575B7",
};

console.log(`updated at: 16.08.2024`);
const App = () => {
  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <Provider store={store}>
      <ReactQueryWrapper>
        <SnackbarProvider>
          <BrowserRouter>
            <LayoutObserver />
            <ScrollController />
            <RootRouter />
          </BrowserRouter>
        </SnackbarProvider>
      </ReactQueryWrapper>
    </Provider>
  );
};

export default App;
